import React, { useState } from "react";
import { useTranslation, Trans } from "react-i18next";
// Google Wallet buttons
import googlePayButtonEn from "../assets/googleWallet/add-to-wallet-svg/svg/enUS_add_to_google_wallet_add-wallet-badge.svg";
import googlePayButtonPl from "../assets/googleWallet/add-to-wallet-svg/svg/pl_add_to_google_wallet_add-wallet-badge.svg";
import googlePayButtonEs from "../assets/googleWallet/add-to-wallet-svg/svg/es419_add_to_google_wallet_add-wallet-badge.svg";
import googlePayButtonEsES from "../assets/googleWallet/add-to-wallet-svg/svg/esES_add_to_google_wallet_add-wallet-badge.svg";
import googlePayButtonDe from "../assets/googleWallet/add-to-wallet-svg/svg/de_add_to_google_wallet_add-wallet-badge.svg";
import googlePayButtonFr from "../assets/googleWallet/add-to-wallet-svg/svg/frFR_add_to_google_wallet_add-wallet-badge.svg";
import googlePayButtonIt from "../assets/googleWallet/add-to-wallet-svg/svg/it_add_to_google_wallet_add-wallet-badge.svg";
import googlePayButtonNl from "../assets/googleWallet/add-to-wallet-svg/svg/nl_add_to_google_wallet_add-wallet-badge.svg";
import googlePayButtonPtBR from "../assets/googleWallet/add-to-wallet-svg/svg/br_add_to_google_wallet_add-wallet-badge.svg";
import googlePayButtonPt from "../assets/googleWallet/add-to-wallet-svg/svg/pt_add_to_google_wallet_add-wallet-badge.svg";
import googlePayButtonUk from "../assets/googleWallet/add-to-wallet-svg/svg/uk_add_to_google_wallet_add-wallet-badge.svg";
import googlePayButtonDa from "../assets/googleWallet/add-to-wallet-svg/svg/dk_add_to_google_wallet_add-wallet-badge.svg";
import googlePayButtonNb from "../assets/googleWallet/add-to-wallet-svg/svg/no_add_to_google_wallet_add-wallet-badge.svg";
import googlePayButtonCs from "../assets/googleWallet/add-to-wallet-svg/svg/cz_add_to_google_wallet_add-wallet-badge.svg";
import googlePayButtonEl from "../assets/googleWallet/add-to-wallet-svg/svg/gr_add_to_google_wallet_add-wallet-badge.svg";
import googlePayButtonHu from "../assets/googleWallet/add-to-wallet-svg/svg/hu_add_to_google_wallet_add-wallet-badge.svg";
// Apple Wallet buttons
import appleWalletButtonEn from "../assets/appleWallet/EN/RGB/US-UK_Add_to_Apple_Wallet_RGB_101421.svg";
import appleWalletButtonPl from "../assets/appleWallet/PL/RGB/PL_Add_to_Apple_Wallet_RGB_102121.svg";
import appleWalletButtonEs from "../assets/appleWallet/ESMX/RGB/ESMX_Add_to_Apple_Wallet_RGB_101821.svg";
import appleWalletButtonEsES from "../assets/appleWallet/ES/RGB/ES_Add_to_Apple_Wallet_RGB_101921.svg";
import appleWalletButtonDe from "../assets/appleWallet/DE/RGB/DE_Add_to_Apple_Wallet_RGB_101421.svg";
import appleWalletButtonFr from "../assets/appleWallet/FR/RGB/FR_Add_to_Apple_Wallet_RGB_102921.svg";
import appleWalletButtonIt from "../assets/appleWallet/IT/RGB/IT_Add_to_Apple_Wallet_RGB_101821.svg";
import appleWalletButtonPt from "../assets/appleWallet/PT/RGB/PT_Add_to_Apple_Wallet_RGB_102021.svg";
import appleWalletButtonPtBR from "../assets/appleWallet/PTBR/RGB/PTBR_Add_to_Apple_Wallet_RGB_102121.svg";
import appleWalletButtonNl from "../assets/appleWallet/NL/RGB/NL_Add_to_Apple_Wallet_RGB_101921.svg";
import appleWalletButtonUk from "../assets/appleWallet/UA/RGB/UA_Add_to_Apple_Wallet_RGB_102121.svg";
import appleWalletButtonSv from "../assets/appleWallet/SE/RGB/SE_Add_to_Apple_Wallet_RGB_102021.svg";
import appleWalletButtonDa from "../assets/appleWallet/DK/RGB/DK_Add_to_Apple_Wallet_RGB_101821.svg";
import appleWalletButtonNb from "../assets/appleWallet/NO/RGB/NO_Add_to_Apple_Wallet_RGB_101921.svg";
import appleWalletButtonFi from "../assets/appleWallet/FI/RGB/FI_Add_to_Apple_Wallet_RGB_102921.svg";
import appleWalletButtonRo from "../assets/appleWallet/RO/RGB/RO_Add_to_Apple_Wallet_RGB_102121.svg";
import appleWalletButtonTr from "../assets/appleWallet/TR/RGB/TR_Add_to_Apple_Wallet_RGB_102121.svg";
import appleWalletButtonCs from "../assets/appleWallet/CZ/RGB/CZ_Add_to_Apple_Wallet_RGB_101421.svg";
import appleWalletButtonEl from "../assets/appleWallet/GR/RGB/GR_Add_to_Apple_Wallet_RGB_102121.svg";
import appleWalletButtonSk from "../assets/appleWallet/SK/RGB/SK_Add_to_Apple_Wallet_RGB_102121.svg";
import appleWalletButtonHu from "../assets/appleWallet/HU/RGB/HU_Add_to_Apple_Wallet_RGB_101421.svg";
import PrimaryButton from "./PrimaryButton";

const BROWSER_DISPLAY_NAMES = {
  facebook: "Facebook",
  instagram: "Instagram",
  tiktok: "TikTok",
  snapchat: "Snapchat",
  twitter: "X",
  linkedin: "LinkedIn",
  pinterest: "Pinterest",
  wechat: "WeChat",
  reddit: "Reddit",
  line: "LINE",
};

const InAppBrowserNotice = ({ downloadUrl, browserName }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const displayName = BROWSER_DISPLAY_NAMES[browserName] ?? browserName;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(downloadUrl);
      setCopied(true);
    } catch {
      try {
        const textarea = document.createElement("textarea");
        textarea.value = downloadUrl;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        const ok = document.execCommand("copy");
        document.body.removeChild(textarea);
        if (ok) setCopied(true);
      } catch {
        // Both clipboard methods failed
      }
    }
  };

  return (
    <div className="mt-5 w-full bg-slate-50/80 rounded-2xl p-4 border border-slate-200/60">
      <p className="text-sm text-slate-600 leading-snug">
        {t("success_message.in_app_browser_notice", { browserName: displayName })}
      </p>
      <button
        onClick={handleCopy}
        className="w-full mt-3 py-2.5 px-4 rounded-xl font-medium text-base bg-slate-700 text-white hover:bg-slate-600 active:bg-slate-800 transition-colors"
      >
        {copied ? `\u2705 ${t("success_message.link_copied")}` : `\uD83D\uDCCB ${t("success_message.copy_link_button")}`}
      </button>
      {copied && (
        <p className="text-sm text-green-600 mt-2.5 font-medium">
          {t("success_message.open_in_safari_hint")}
        </p>
      )}
    </div>
  );
};

const SuccessMessage = ({
  deviceType,
  onInstallGooglePass,
  isFetchingGooglePass,
  googlePassReady,
  onInstallApplePass,
  isFetchingApplePass,
  applePassReady,
  firstName,
  isDemo,
  companyId,
  passTemplateId,
  isInAppBrowser,
  browserName,
  applePassDownloadUrl,
}) => {
  const { t, i18n } = useTranslation();
  const [applePassInstallAttempted, setApplePassInstallAttempted] =
    useState(false);

  // Select wallet button images based on language
  const langFull = i18n.language;
  const lang = langFull.split("-")[0];
  const googlePayButtonSvg =
    { "es-ES": googlePayButtonEsES, "pt-BR": googlePayButtonPtBR }[langFull] ||
    { pl: googlePayButtonPl, es: googlePayButtonEs, de: googlePayButtonDe, fr: googlePayButtonFr, it: googlePayButtonIt, nl: googlePayButtonNl, pt: googlePayButtonPt, uk: googlePayButtonUk, da: googlePayButtonDa, nb: googlePayButtonNb, cs: googlePayButtonCs, el: googlePayButtonEl, hu: googlePayButtonHu }[lang] ||
    googlePayButtonEn;
  const appleWalletButtonSvg =
    { "es-ES": appleWalletButtonEsES, "pt-BR": appleWalletButtonPtBR }[langFull] ||
    { pl: appleWalletButtonPl, es: appleWalletButtonEs, de: appleWalletButtonDe, fr: appleWalletButtonFr, it: appleWalletButtonIt, pt: appleWalletButtonPt, nl: appleWalletButtonNl, uk: appleWalletButtonUk, sv: appleWalletButtonSv, da: appleWalletButtonDa, nb: appleWalletButtonNb, fi: appleWalletButtonFi, ro: appleWalletButtonRo, tr: appleWalletButtonTr, cs: appleWalletButtonCs, el: appleWalletButtonEl, sk: appleWalletButtonSk, hu: appleWalletButtonHu }[lang] ||
    appleWalletButtonEn;

  const faveCardWebsiteUrl = `https://favecard.co?utm_source=pass_installation_form&utm_medium=web&companyId=${encodeURIComponent(
    companyId || ""
  )}`;

  const demoMarketingBlock2 = (
    <p className="text-md text-slate-600 mb-6">
      <Trans
        i18nKey="success_message.demo_marketing_block_2"
        components={[
          <a
            href={faveCardWebsiteUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-blue-600 hover:text-blue-800 underline"
          />,
        ]}
      />
    </p>
  );

  const poweredByFaveCard = (
    <div className="text-center mt-6">
      <p className="text-xs text-slate-500">
        <Trans
          i18nKey="success_message.powered_by"
          components={[
            <a
              href={faveCardWebsiteUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-blue-600 hover:text-blue-800 underline"
            />,
          ]}
        />
      </p>
    </div>
  );

  const handleGoogleInstallClick = () => {
    onInstallGooglePass();
  };

  const handleAppleInstallClick = () => {
    if (applePassReady && !isFetchingApplePass) {
      onInstallApplePass();
      setApplePassInstallAttempted(true);
    }
  };

  const handleAppleRetryInstallClick = () => {
    if (applePassReady && !isFetchingApplePass) {
      onInstallApplePass();
    }
  };

  const ApplePassAttemptedStateView = () => (
    <div className="flex flex-col items-center text-center w-full py-4">
      <p
        className="text-md text-slate-600 mb-6"
        dangerouslySetInnerHTML={{
          __html: t("success_message.apple_pass_attempted_state_message_1"),
        }}
      />
      <p className="text-xs text-slate-500">
        <Trans
          i18nKey="success_message.apple_pass_attempted_state_message_2"
          components={[
            <button
              onClick={handleAppleRetryInstallClick}
              disabled={isFetchingApplePass || !applePassReady}
              className={`font-medium text-blue-600 hover:text-blue-800 underline focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed`}
            />,
          ]}
        />
      </p>
    </div>
  );

  const renderInitialView = () => (
    <div className="text-center p-2 sm:p-6 relative z-10">
      <h2 className="text-2xl text-slate-700 font-heading mb-2">
        {applePassInstallAttempted && deviceType === "apple"
          ? t("success_message.apple_pass_install_attempted_title")
          : isDemo
            ? t("success_message.demo_title")
            : firstName
              ? t("success_message.user_card_ready_title", { firstName })
              : t("success_message.card_ready_title")}
      </h2>

      <div className="text-md text-slate-600 mb-2">
        {deviceType === "android" && renderAndroidContent()}
        {deviceType === "apple" && renderAppleContent()}
        {deviceType !== "android" &&
          deviceType !== "apple" &&
          t("success_message.generic_device_message")}
      </div>
    </div>
  );

  const renderAndroidContent = () => (
    <>
      {isDemo ? (
        <>
          <p className="text-md text-slate-600 mb-4">
            {t("success_message.demo_marketing_block_1_android")}
          </p>
          <button
            onClick={handleGoogleInstallClick}
            disabled={isFetchingGooglePass || !googlePassReady}
            className={`w-full flex items-center justify-center mt-4 mb-8 p-2 ${
              isFetchingGooglePass || !googlePassReady
                ? "cursor-not-allowed opacity-50"
                : "cursor-pointer"
            }`}
            aria-label={t("success_message.add_to_google_wallet_aria")}
          >
            <img
              src={googlePayButtonSvg}
              alt={t("success_message.add_to_google_wallet_alt")}
              className="h-10"
            />
          </button>
          {demoMarketingBlock2}
          <PrimaryButton
            text={t("success_message.create_card_button")}
            onClick={() =>
              window.open(faveCardWebsiteUrl, "_blank", "noopener,noreferrer")
            }
            loading={false}
          />
        </>
      ) : (
        <>
          <p className="text-md text-slate-600 mb-2 leading-snug">
            {t("success_message.add_to_google_wallet_instruction")}
          </p>
          <button
            onClick={handleGoogleInstallClick}
            disabled={isFetchingGooglePass || !googlePassReady}
            className={`w-full flex items-center justify-center p-2 mt-4 mb-3 ${
              isFetchingGooglePass || !googlePassReady
                ? "cursor-not-allowed opacity-50"
                : "cursor-pointer"
            }`}
            aria-label={t("success_message.add_to_google_wallet_aria_real")}
          >
            <img
              src={googlePayButtonSvg}
              alt={t("success_message.add_to_google_wallet_alt_real")}
              className="h-10"
            />
          </button>
          <div className="text-center mt-2">
            <p className="text-xs text-slate-500">
              {t("success_message.google_play_redirect_info")}
            </p>
            <a
              href={`https://wallet.google/intl/${{ "es-ES": "es_es", "pt-BR": "pt_br" }[langFull] || { pl: "pl_pl", es: "es_419", de: "de_de", fr: "fr_fr", it: "it_it", pt: "pt_pt", nl: "nl_nl", uk: "uk_ua", sv: "sv_se", da: "da_dk", nb: "no_no", fi: "fi_fi", ro: "ro_ro", tr: "tr_tr", cs: "cs_cz", el: "el_gr", sk: "sk_sk", hu: "hu_hu" }[lang] || "en_us"}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-slate-500 hover:text-slate-700 underline"
            >
              {t("success_message.google_wallet_benefits_link")}
            </a>
          </div>
          {!isFetchingGooglePass &&
            !googlePassReady &&
            deviceType === "android" && (
              <p className="text-red-500 text-sm mt-2">
                {t("success_message.google_pass_fail_message")}
              </p>
            )}
          {poweredByFaveCard}
        </>
      )}
    </>
  );

  const renderAppleContent = () => {
    // In-app browser: show Wallet button + fallback notice, with "attempted" state support
    if (isInAppBrowser && applePassDownloadUrl) {
      return (
        <>
          {applePassInstallAttempted ? (
            <>
              <ApplePassAttemptedStateView />
              <InAppBrowserNotice
                downloadUrl={applePassDownloadUrl}
                browserName={browserName ?? ""}
              />
            </>
          ) : (
            <>
              <p className="text-md text-slate-600 mb-6">
                {t("success_message.add_to_apple_wallet_instruction")}
              </p>
              <button
                onClick={handleAppleInstallClick}
                disabled={isFetchingApplePass || !applePassReady}
                className={`w-full flex items-center justify-center mt-2 p-2 ${
                  isFetchingApplePass || !applePassReady
                    ? "cursor-not-allowed opacity-50"
                    : "cursor-pointer"
                }`}
                aria-label={t("success_message.add_to_apple_wallet_aria_real")}
              >
                <img
                  src={appleWalletButtonSvg}
                  alt={t("success_message.add_to_apple_wallet_alt_real")}
                  className="h-14"
                />
              </button>
              <InAppBrowserNotice
                downloadUrl={applePassDownloadUrl}
                browserName={browserName ?? ""}
              />
            </>
          )}
          {poweredByFaveCard}
        </>
      );
    }

    return (
    <>
      {isDemo ? (
        <>
          {!applePassInstallAttempted && (
            <p className="text-md text-slate-600 mb-4">
              {t("success_message.demo_marketing_block_1_apple")}
            </p>
          )}

          {applePassInstallAttempted ? (
            <ApplePassAttemptedStateView />
          ) : (
            <button
              onClick={handleAppleInstallClick}
              disabled={isFetchingApplePass || !applePassReady}
              className={`w-full flex items-center justify-center mt-4 mb-8 p-2 ${
                isFetchingApplePass || !applePassReady
                  ? "cursor-not-allowed opacity-50"
                  : "cursor-pointer"
              }`}
              aria-label={t("success_message.add_to_apple_wallet_aria")}
            >
              <img
                src={appleWalletButtonSvg}
                alt={t("success_message.add_to_apple_wallet_alt")}
                className="h-14"
              />
            </button>
          )}
          {demoMarketingBlock2}
          <PrimaryButton
            text={t("success_message.create_card_button")}
            onClick={() =>
              window.open(faveCardWebsiteUrl, "_blank", "noopener,noreferrer")
            }
            loading={false}
          />
        </>
      ) : (
        <>
          {applePassInstallAttempted ? (
            <ApplePassAttemptedStateView />
          ) : (
            <>
              <p className="text-md text-slate-600 mb-6">
                {t("success_message.add_to_apple_wallet_instruction")}
              </p>
              <button
                onClick={handleAppleInstallClick}
                disabled={isFetchingApplePass || !applePassReady}
                className={`w-full flex items-center justify-center mt-2 p-2 ${
                  isFetchingApplePass || !applePassReady
                    ? "cursor-not-allowed opacity-50"
                    : "cursor-pointer"
                }`}
                aria-label={t("success_message.add_to_apple_wallet_aria_real")}
              >
                <img
                  src={appleWalletButtonSvg}
                  alt={t("success_message.add_to_apple_wallet_alt_real")}
                  className="h-14"
                />
              </button>
              <div className="text-center mt-2">
                <p className="text-xs text-slate-500">
                  {t("success_message.apple_wallet_reminder")}
                </p>
              </div>
              {!isFetchingApplePass &&
                !applePassReady &&
                deviceType === "apple" && (
                  <p className="text-red-500 text-sm mt-2">
                    {t("success_message.apple_pass_fail_message")}
                  </p>
                )}
              {poweredByFaveCard}
            </>
          )}
        </>
      )}
    </>
    );
  };

  return renderInitialView();
};

export default SuccessMessage;
